(function ($) {
  const initializeBlock = function ($block) {
    $block.find(".readBio").on("click", (e) => {
      e.preventDefault();
      const teamMember = $(e.target).data("team-member");
      $(".teamGrid-popup__wrapper[data-team-member=" + teamMember + "]")
        .clone()
        .appendTo(".teamGrid-popup");
      $(".teamGrid-popup").addClass("active");
      $('body').toggleClass('u-noScroll')
    });
  };

  $(document).ready(function () {
    $(".block--team").each(function () {
      initializeBlock($(this));
    });
  });

  $(document).on("click", ".teamGrid-popup__close", function (e) {
    e.preventDefault();
    $(".teamGrid-popup").removeClass("active");
    $(".teamGrid-popup").html("");
    $('body').toggleClass('u-noScroll')
  });

  if (window.acf) {
    window.acf.addAction("render_block_preview/type=team", initializeBlock);
  }
})(jQuery);
